import React from 'react';
import Form from '../../../../components/forms/utils/Form';
import SingleLineField from '../../../../components/forms/SingleLineField';
import DropdownField from '../../../../components/forms/DropdownField';
import { typeOptions } from '../AdvancedWebsites';
import { httpUrlRule } from '../../../../utils/validators';
import { useMutation } from '@apollo/client';
import { UPDATE_WEBSITE } from '../../../../utils/api/website';
import { useOutletContext } from 'react-router-dom';
import { Switch } from '../../../../components/lists/listComponents/Switch';
import FormItem from '../../../../components/forms/utils/FormItem';


const WebsiteDetails = () => {
  const { website } = useOutletContext<any>();

  const [updateWebsite] = useMutation(UPDATE_WEBSITE)

  const handleSubmit = async (values: any, changedValues: any) => {
    updateWebsite({
      variables: { id: website._id, record: changedValues }
    })
  }
  return (
    <Form
      defaultValues={website}
      className="mt-8 flex-1 relative overflow-y-auto focus:outline-none bg-white rounded-md py-6 px-6"
      onSubmit={handleSubmit}
      submitButtonText="Save"
    >
      <SingleLineField
        top
        label="Website"
        htmlfor="name"
        required
      />
      <SingleLineField
        label="URL"
        htmlfor="url"
        required
        rules={{ validate: { format: httpUrlRule } }}
      />
      <DropdownField
        label="Type"
        options={typeOptions}
        htmlfor="type"
        required
      />
      
      <SingleLineField
        label="Minimum spend"
        htmlfor="minimumSpend"
        type="number"
      />

      <SingleLineField
        label="Monthly visitors"
        htmlfor="monthlyVisitors"
        type="number"
      />

      <FormItem label="Enabled on marketplace">
        <Switch name='enabledOnMarketplace' />
      </FormItem>
    </Form>
  );
};

export default WebsiteDetails;


